"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membership = void 0;
const createApi_1 = require("../../../helpers/createApi");
const get = (caller) => ({ accountId, accountIds, ...getParameters }) => {
    const url = `/accounts/${accountId}/organizations/default/membership`;
    const params = {
        ...getParameters,
    };
    accountIds && (params.account_ids = accountIds.join(' '));
    return caller(url).get(params);
};
const put = (caller) => ({ accountId, bypassErrorHandlers, payload }) => {
    const url = `/accounts/${accountId}/organizations/default/membership`;
    return caller(url).put(payload, { bypassErrorHandlers });
};
const deleteMembership = (caller) => ({ accountId, userId, organizationId = 'default' }) => {
    const url = `/accounts/${accountId}/organizations/${organizationId}/membership/${userId}`;
    return caller(url).delete();
};
const patch = (caller) => ({ accountId, userId, organizationId = 'default', payload }) => {
    const url = `/accounts/${accountId}/organizations/${organizationId}/membership/${userId}`;
    return caller(url).patch(payload);
};
exports.membership = (0, createApi_1.createAPIFactory)({
    get,
    put,
    delete: deleteMembership,
    patch,
});
//# sourceMappingURL=api.js.map